/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OnboardingModelState from './OnboardingModelState';
import OnboardingTodoState from './OnboardingTodoState';

/**
 * The OnboardingStateRequest model module.
 * @module model/OnboardingStateRequest
 * @version V1
 */
class OnboardingStateRequest {
    /**
     * Constructs a new <code>OnboardingStateRequest</code>.
     * @alias module:model/OnboardingStateRequest
     */
    constructor() { 
        
        OnboardingStateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OnboardingStateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OnboardingStateRequest} obj Optional instance to populate.
     * @return {module:model/OnboardingStateRequest} The populated <code>OnboardingStateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OnboardingStateRequest();

            if (data.hasOwnProperty('todoState')) {
                obj['todoState'] = OnboardingTodoState.constructFromObject(data['todoState']);
            }
            if (data.hasOwnProperty('modelState')) {
                obj['modelState'] = OnboardingModelState.constructFromObject(data['modelState']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OnboardingStateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OnboardingStateRequest</code>.
     */
    static validateJSON(data) {
        // validate the optional field `todoState`
        if (data['todoState']) { // data not null
          OnboardingTodoState.validateJSON(data['todoState']);
        }
        // validate the optional field `modelState`
        if (data['modelState']) { // data not null
          OnboardingModelState.validateJSON(data['modelState']);
        }

        return true;
    }


}



/**
 * @member {module:model/OnboardingTodoState} todoState
 */
OnboardingStateRequest.prototype['todoState'] = undefined;

/**
 * @member {module:model/OnboardingModelState} modelState
 */
OnboardingStateRequest.prototype['modelState'] = undefined;






export default OnboardingStateRequest;

